import logoInvoice from '../../assets/img/logos/logoCienytech.png';

export default {
  institution: 'Cienytech',
  logo: logoInvoice,
  address: 'Rúa Xosé Chao Rego, 10 Bajo <br/> 15705 – Santiago de Compostela (A Coruña)',
  tax: 0.08,
  currency: '€',
  email: 'info@cienytech.com',
  telefono: '981 966 346',
  web: 'www.cienytech.com', 
  summary: {
    invoice_no: 14,
    order_number: 'AD20294',
    invoice_date: '2018-09-25',
    payment_due: 'Upon receipt',
    amount_due: 19688.4
  },
  products: [
    {
      name: 'Platinum web hosting package',
      description: 'Down 35mb, Up 100mb',
      quantity: 2,
      rate: 65
    },
    {
      name: '2 Page website design',
      description: 'Includes basic wireframes and responsive templates',
      quantity: 1,
      rate: 2100
    },
    {
      name: 'Mobile App Development',
      description: 'Includes responsive navigation',
      quantity: 8,
      rate: 500
    },
    {
      name: 'Web App Development',
      description: 'Includes react spa',
      quantity: 6,
      rate: 2000
    }
  ]
};
